import { ActionIcon } from '@mantine/core'
import { IconMinus, IconPlus, IconTrash } from '@tabler/icons-react'
import clsx from 'clsx'

import { Text } from 'src/components/Text/Text'

import styles from './Stepper.module.scss'

interface StepperProps {
  value: number
  maxValue?: number
  onChange: (value: number) => void
  small?: boolean
  deleteOnZero?: boolean
  isBusy?: boolean
  disabled?: boolean
}

export const Stepper = ({
  value,
  maxValue = 999,
  onChange,
  small = false,
  deleteOnZero = false,
  isBusy = false,
  disabled = false,
}: StepperProps) => (
  <div className={clsx(styles.stepper, small && styles.small)} data-testid="stepper">
    <ActionIcon
      variant="default"
      size={small ? 30 : 42}
      className={clsx(styles.button, deleteOnZero && value <= 1 && styles.deleting)}
      onClick={() => onChange(value - 1)}
      disabled={disabled || isBusy || (!deleteOnZero && value === 1)}
      data-testid="subtract-btn"
      aria-label="minus"
    >
      {deleteOnZero && value <= 1 ? (
        <IconTrash size={small ? 12 : 18} />
      ) : (
        <IconMinus stroke={1.6} size={small ? 12 : 18} />
      )}
    </ActionIcon>
    <Text bold className={styles.value}>
      {value}
    </Text>
    <ActionIcon
      variant="default"
      size={small ? 30 : 42}
      className={styles.button}
      onClick={() => onChange(value + 1)}
      disabled={disabled || isBusy || value === maxValue}
      data-testid="plus-btn"
      aria-label="plus"
    >
      <IconPlus size={small ? 12 : 18} />
    </ActionIcon>
  </div>
)
